import type { TranscriptMethod } from './model';

const methodLabels: Record<TranscriptMethod, string> = {
  audio_asr: 'Speech recognition over the audio',
  automatic_captions: 'Platform-generated automatic captions',
  manual_captions: 'Creator-written captions',
  platform_subtitles: 'Platform-published subtitle track',
  unknown: 'Unknown - caption versus speech recognition was not disclosed',
};

/**
 * The reader's one-line answer to "where did these words come from". It decides
 * whether a line is quotable: creator captions are written, everything else is
 * recognized and carries recognition error.
 */
export const transcriptMethodLabel = (method: TranscriptMethod) => methodLabels[method];

export const formatTranscriptTimestamp = (seconds: number) => {
  const minutes = Math.floor(seconds / 60);
  const remainder = Math.floor(seconds % 60);
  return `${minutes}:${String(remainder).padStart(2, '0')}`;
};
